import { FC, useState } from "react";
import SubmitItem from "../../../components/template/SubmitItem/SubmitItem";
import { FieldValues, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../components/atom/Toast/Toast";
import { ROLE_URL } from "../../../utils/endpoints";
import { handleSubmitItem } from "../../../helpers/handleSubmitItem";
import { RolesItemSchema } from "../data/RolesItemSchema";
import RolesSubmitForm from "./RolesSubmitForm";
import { useStepper } from "../../../hooks/stepper/useStepper";
import { StepperConfig } from "../../../types/Components/Stepper/StepperConfig";
import { AlertDialogConfig } from "../../../types/Components/Alert/AlertDialogConfig";
import api from "../../../utils/api";

const NewRole: FC = () => {
  const { addToast } = Toast();
  const navigate = useNavigate();
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);

  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    trigger,
    watch,
    setValue,
  } = useForm({
    resolver: zodResolver(RolesItemSchema),
    mode: "onChange",
    shouldUseNativeValidation: false,
  });

  const onSubmit = async (data: FieldValues) => {
    const bodyRequest = {
      name: data.name,
      roleLevelId: data.organizationLevelOption.id,
      roleTypeId: 1,
      permissions: data.permissions,
    };
    await handleSubmitItem(
      () => api.post(ROLE_URL, bodyRequest),
      addToast,
      setIsLoaded,
      "Create",
      "Perfil criado",
    );
    navigate("/perfis");
  };

  const steps = [
    { title: "Preencher as informações do perfil", description: "Passo 1" },
    { title: "Verificar as informações do perfil", description: "Passo 2" },
  ];

  const { currentStep, handleNext, handleBack, handleFinalSubmit } = useStepper(
    steps,
    trigger,
    handleSubmit,
    onSubmit,
    setHasInteracted,
  );

  const stepperConfig: StepperConfig = {
    nextButtonName: "Criar perfil",
    steps,
    onNext: currentStep === steps.length - 1 ? handleFinalSubmit : handleNext,
    onBack: handleBack,
    isNextActive: true,
    isFinalStep: currentStep === steps.length - 1,
    currentStep,
  };

  const alertDialogConfig: AlertDialogConfig = {
    setIsAlertOpen,
    isAlertOpen,
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <SubmitItem
        title="Criar perfil"
        formTitle="Dados pessoais"
        hasAlert={currentStep === steps.length - 1}
        hasSubmitFooter
        hasStepper
        stepperConfig={stepperConfig}
        alertDialogConfig={alertDialogConfig}
        isLoaded={isLoaded}
        isDirty={isDirty}
      >
        <RolesSubmitForm
          errors={errors}
          control={control}
          watch={watch}
          isDisabled={currentStep === steps.length - 1}
          setValue={setValue}
          hasInteracted={hasInteracted}
          setHasInteracted={setHasInteracted}
        />
      </SubmitItem>
    </form>
  );
};

export default NewRole;
